import { FC } from "react";
import InputTemplate, { InputProps as InputTemplateProps } from "@sbgsportssoftware/input";

const Input: FC<InputTemplateProps> = ({ ...props }) => {
    return <InputTemplate {...props} />;
};

export default Input;
